import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { TitleReserveStyled } from "./styled";

const TitleReserve = ({ theme_standard, title_reserve, theme_text_black }) => {
  const customClass = cx({
    theme_standard: theme_standard,
    theme_text_black: theme_text_black,
  });
  return (
    <TitleReserveStyled className={customClass}>
      {title_reserve}
    </TitleReserveStyled>
  );
};

TitleReserve.propTypes = {};

export default TitleReserve;
